/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import NavigationBar from '../components/NavBar'
import FormsDocuments from '../components/FormsDocuments'
import { useSelector, useDispatch } from 'react-redux';
import { 
    addDrivers,
    selectDrivers
} from '../features/drivers/driversSlice'
import {
    addImages,
    selectImages
} from '../features/imagesSliceFile/imagesSlice'
import Documents from '../components/Documents'
// import { 
//     selectDocDriver,
//     addDocDriver
// } from '../features/docDrivers/docDriversSlice'

const determineOffboarded = (offboradedContent, selectedFunctionDate) => {
    switch (offboradedContent) {
        case 'OffboardedForever':
            return false
        case 'Active':
            return true
        case 'verified':
            return true
        case null:
            return true        
        default:
            return true
    }
}

const outsideList = []

const DriverDocuments = (props) => {
    // function for determining next tuesday
    const determineTuesday = () => {

        // obtain the current date
        let currentDate = new Date()

        // return date
        let returnDate = new Date()

        // loop through adding a day until tuesday is found
        for( let i = 1; i < 9; i++) {
            // check the day
            returnDate.setDate(currentDate.getDate() + i)
            
            if (returnDate.getDay() === 2) {
                return new Date(returnDate)
            }
        }
    }

    useEffect( () => {
        if (props.superUser) {

        } else {
            async function postData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            async function putData(url = '', data={}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'PUT', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                    body: JSON.stringify(data)
                });
                return response ? response.json() : console.log('no reponse')
            };
            postData('https://backendpajamas.herokuapp.com/tracker/', {
                ID: props.user_id
            }).then( response => {
                let theDate = new Date()
                let theTime = `${theDate.getHours()}:${theDate.getMinutes()}:${theDate.getSeconds()}`
                if (response.data) {
                    response.data.forEach( ele => {
                        if (ele.date === new Date().toDateString()) {
                            let localPagesList = [...ele.pages_list, `${ele.pages_list.length}+driverdoc+${theTime}`]
                            putData(`https://backendpajamas.herokuapp.com/trackeradditions/${ele._id}/`, {
                                pages_list: localPagesList
                            })
                        }
                    })
                }
            })
        }
    }, [])
    const reduxDrivers = useSelector(selectDrivers)
    const imageData = useSelector(selectImages)

    var CryptoJS = require("crypto-js");
    const [ data, setData ] = useState(null)
    const [ selectedCity, setSelectedCity ] = useState('DBS2')
    const [ driverList, setDriverList ] = useState([])
    const [ listClassName, setListClassName ] = useState('')
    const [ driverSearchArray, setDriverSearchArray ] = useState([])
    const [ makeSearchBarVisible, setMakeSearchBarVisible ] = useState('dashboard_form_divs_name_bar_none')
    const [ nameValue, setNameValue ] = useState('')
    const [ arrowSelect, setArrowSelect ] = useState(0)
    const [ nameList, setNameList ] = useState(null)
    const [ shorterList , setShorterList ] = useState([])
    const [ selectedDriver, setSelectedDriver ] = useState(null)
    const [ driverForOffboarding, setDriverForOffboarding ] = useState(null)
    const [ reload, setReload] = useState(0)
    const [ otherReload, setOtherReload ] = useState(0)
    const [ errorMessage, setErrorMessage ] = useState(null)
    const [ drivers, setDrivers ] = useState([])
    const [ images, setImages ] = useState([])
    const [ content, setContent ] = useState(null)

    // state for dropdown
    const [stationOptions, setStationOptions] = useState(null)
    // redux set state
        // view the redux state
    useEffect( () => {
        if (reduxDrivers.length > 0) {
            // set the drivers
            let localDrivers = [...reduxDrivers]
            let localSortedArray = []
            localDrivers.forEach( driver => {
                if (driver.status === 'verified') {
                    localSortedArray.push(driver)
                }
            })
            localSortedArray.sort( (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1: -1))

            setDrivers(localSortedArray)
        }
    }, [reduxDrivers])
    // redux stuff
    const dispatch = useDispatch()

    useEffect( () => {
        async function getData(url = '') {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'GET', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
            });

            return response ? response.json() : console.log('no reponse')
        };

        getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
            console.log(response)
            response.results.sort( (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1: -1))
            dispatch(addDrivers(response.results))
        })
    }, [reload])

    // function for handling changing the dropdiwn selection
    const handleSelectCity = (e, cityAbbreviation) => {
        setSelectedCity(cityAbbreviation)
    }

    // change color and select name from list
    const handleNameSelection = (e, nameSelection) => {
        setListClassName(nameSelection)
        drivers.forEach( driver => {
            if (driver.name === nameSelection) {
                setDriverForOffboarding(driver)
                setNameValue(driver.name)
            }
        })
    }

    // map the drivers
    // changes when the data changes
    useEffect( () => {
        const mapTheDrivers = () => {
        let localArray = []
        if (drivers) {
            drivers.forEach( driver => {
                if (driver.location === selectedCity) {
                    if (determineOffboarded(driver.status)) {
                        localArray.push(
                            {name: driver.name, offBoard: driver.offBoard}
                        )
                    }
                }
            })
        }

            localArray.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
            localArray.forEach( (ele, id) => {
                if (ele.offBoard) {
                    localArray[id] = (
                        <>
                            <h3 className={ele.name === listClassName ? 'driver_list_text selected_forms_name' : 'driver_list_text'} id='offBoardPending' onClick={(e, theNAme) => handleNameSelection(e, ele.name)}>
                                {ele.name} {ele.offBoard ? `| ${new Date(ele.offBoard).toLocaleDateString()}`: null}
                            </h3>
                            <br/>
                        </>
                    )
                } else {
                    localArray[id] = (
                        <>
                            <h3 className={ele.name === listClassName ? 'driver_list_text selected_forms_name' : 'driver_list_text'} onClick={(e, theNAme) => handleNameSelection(e, ele.name)}>
                                {ele.name} {ele.offBoard ? `| ${new Date(ele.offBoard).toLocaleDateString()}`: null}
                            </h3>
                            <br/>
                        </>
                    )
                }
            })
            return localArray
        }
        setDriverList(mapTheDrivers())
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drivers, otherReload, listClassName, selectedCity])

    // get rid off error screen
    const handleDeleteError = () => {
        setErrorMessage(null)
    }

    const handleReturn = () => {
        setErrorMessage(null)
    }

    // handle checking if they want to offboard
    const handleDeactivation = () => {
        if (driverForOffboarding) {
            setErrorMessage(
                <div className='makeMeBig'> 
                    <div className='deletionObjectionTwo'>
                        would you like to offboard {driverForOffboarding.name}?
                        <div>
                            <button className='deleteButton' onClick={() => offBoardTheDriver()}>Delete</button> 
                            <button className='returnButton' onClick={handleReturn}>Return</button> 
                        </div>
                    </div>
                </div>
            )
        }
    }

    // actually offboard the driver
    const offBoardTheDriver = () => {
        async function putData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'PUT', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
                body: JSON.stringify(data)
                });

            return response ? response.json() : console.log('no reponse')
        };
        let theDate = new Date()
        // handle submitting document to backend
            if (driverForOffboarding !== null) {
                if (props.superUser) {
                    putData(`https://backendpajamas.herokuapp.com/drivers/${driverForOffboarding.driver_id}/`, {
                        approvedBy: props.user_name,
                        approvedDateAndTime: theDate.toDateString(),
                        offBoard: determineTuesday().toDateString()
                    }).then( response => {
                        console.log(response)
                        // postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                        //     "driver_id": driverForOffboarding.driver_id
                        // }).then( responseImages => {
                        //     responseImages.data.forEach( image => {
                        //         if (image.verified !== 'offboarded') {
                        //             putData(`https://backendpajamas.herokuapp.com/images/${image.image_id}/`, {
                        //                 verified: 'offboarded'
                        //             })
                        //         }
                        //     })
                        // })
                        let myVar = reload
                        let myReloadVar = myVar + 1
                        setReload(myReloadVar)
                        setErrorMessage(null)
                        setSelectedDriver(null)
                    })
                } else {
                    if (props.station.includes(driverForOffboarding.location)) {
                        putData(`https://backendpajamas.herokuapp.com/drivers/${driverForOffboarding.driver_id}/`, {
                            approvedBy: props.user_name,
                            approvedDateAndTime: theDate.toDateString(),
                            offBoard: determineTuesday().toDateString()
                        }).then( response => {
                            console.log(response)
                            // postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                            //     "driver_id": driverForOffboarding.driver_id
                            // }).then( responseImages => {
                            //     responseImages.data.forEach( image => {
                            //         if (image.verified !== 'offboarded') {
                            //             putData(`https://backendpajamas.herokuapp.com/images/${image.image_id}/`, {
                            //                 verified: 'offboarded'
                            //             })
                            //         }
                            //     })
                            // })
                            let myVar = reload
                            let myReloadVar = myVar + 1
                            setReload(myReloadVar)
                            setErrorMessage(null)
                            setSelectedDriver(null)
                        })
                    } else {
                        setErrorMessage(
                            <div className='errorMessageAllPages'>
                                <h3 id='errorMessage'>Please contact supervisor if trying to alter data about driver not in your depot. </h3>
                                <button className='errorButton' onClick={handleDeleteError}>Return</button>
                            </div>
                        )
                    }
                }
        }
    }

    // select name
    const handleNameClick = (e, theName) => {
        makeSearchUnderBar('', 10)
        setNameValue(theName)
    }

    // search bar 
    const makeSearchUnderBar = (theValue, theLength) => {
        if (theValue !== '' && theLength <= 3) {
            setMakeSearchBarVisible('dashboard_form_divs_name_bar_forms')
        } else {
            setMakeSearchBarVisible('dashboard_form_divs_name_bar_none')
        }
    }

    // search bar function
    const handleChange = (e) => {
        if (drivers) {
            setNameValue(e.target.value)
            makeSearchUnderBar(e.target.value, nameValue.length)
            let localArray = []
            drivers.forEach( (ele, id) => {
                if (determineOffboarded(ele.status)) {
                    if (ele.name.toLowerCase().includes(e.target.value.toLowerCase()) && e.target.value !== '' && e.target.value.length < 4) {
                        localArray.push(
                            <h4 className='name_suggestions' id={id} onClick={(e, theName) => handleNameClick(e, `${ele.name}`)} >{ele.name}</h4>
                        )
                    }
                }
            })
            setDriverSearchArray(localArray)
        }
    } 

    // handle arrow keys
    const handleArrowKeys = (e) => {
        let mylocalArray = []
        if (driverSearchArray) {
            if (props) {
                let localVar = arrowSelect
                if (e.keyCode === 13) {
                    setNameValue(driverSearchArray[localVar].props.children)
                    makeSearchUnderBar('', 10)
                    setArrowSelect(0)
                }
                if (e.keyCode === 38 ) {
                    if (localVar > 0) {
                        driverSearchArray[localVar] = <h4 className='name_suggestions' onClick={(e, theName) => handleNameClick(e, `${driverSearchArray[localVar].props.children}`)} >{driverSearchArray[localVar].props.children}</h4>
                        let localVarChange = localVar-1
                        setArrowSelect(localVarChange)
                        driverSearchArray[localVarChange] = <h4 className='name_suggestions_arrow_selection_down' onClick={(e, theName) => handleNameClick(e, `${driverSearchArray[localVarChange].props.children}`)} >{driverSearchArray[localVarChange].props.children}</h4>
                    }
                }
                for(let i = localVar; localVar - 5 > i > 0; i++) {
                    mylocalArray.shift(driverSearchArray[i])
                }
                if (e.keyCode === 40) {
                    if (localVar < driverSearchArray.length - 1) {
                        driverSearchArray[localVar] = <h4 className='name_suggestions' onClick={(e, theName) => handleNameClick(e, `${driverSearchArray[localVar].props.children}`)} >{driverSearchArray[localVar].props.children}</h4>
                        let localVarChange = localVar + 1
                        setArrowSelect(localVarChange)
                        driverSearchArray[localVarChange] = <h4 className='name_suggestions_arrow_selection_up' onClick={(e, theName) => handleNameClick(e, `${driverSearchArray[localVarChange].props.children}`)} >{driverSearchArray[localVarChange].props.children}</h4>
                    }
                    for(let i = localVar; i < driverSearchArray.length - 1; i++) {
                        mylocalArray.push(driverSearchArray[i])
                    }
                }
            }
            setShorterList(mylocalArray)
        }
    }

    // handle mapping selected driver to component
    useEffect( () => {
        async function postData(url = '', data = {}) {
            let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
            let originalText = bytes.toString(CryptoJS.enc.Utf8);
            const response = await fetch(url, {
                method: 'POST', 
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${originalText}`
                },
            });

            return response ? response.json() : console.log('no reponse')
        };
        if (nameValue) {
            drivers.forEach( ele => {
                if (ele.name === nameValue) {
                    postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                        "driver_id": ele.driver_id
                    }).then( response => {
                        let localDriver = {...ele}
                        localDriver.imgArray = [...response.data]
                        setSelectedDriver(localDriver)
                    })
                }
            })
        }
    }, [nameValue, data])

    // make the driver go away
    const makeAReRender = (selectedDriverReturn) => {
        if (selectedDriverReturn) {
            async function postData(url = '', data = {}) {
                let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
                let originalText = bytes.toString(CryptoJS.enc.Utf8);
                const response = await fetch(url, {
                    method: 'POST', 
                    mode: 'cors',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Token ${originalText}`
                    },
                });
    
                return response ? response.json() : console.log('no reponse')
            };

            postData(`https://backendpajamas.herokuapp.com/driverimages/`, {
                "driver_id": selectedDriverReturn.driver_id
            }).then( response => {
                let localDriver = {...selectedDriverReturn}
                localDriver.imgArray = [...response.data]
                setSelectedDriver(localDriver)
            })
        }
    }

    // make the documents appear
    useEffect( () => {
        if (selectedDriver) {
            setContent(
                <>
                    <Documents 
                        selectedDriver={selectedDriver} 
                        loginName={props.user_name} 
                        station={props.station}
                        email={props.user_email}
                        superUser={props.superUser ? true : false}
                        userName={props.user_name}
                        reRender={makeAReRender}
                    />
                </>
            )
        } else {
            setContent(null)
        }
    }, [selectedDriver])

    useEffect( () => {
        if (props.superUser === true) {
            setStationOptions(
                <ol>
                    <li className="menu-item" id="makeMeWhite"><a href="#0" id="makeMeWhite">{selectedCity}</a>
                        <ol className="sub-menu" id="makeMeWhite">
                            <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DBS2')}><a id="makeMeWhiteli" href="#0">DBS2</a></li>
                            <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DSN1')}><a id="makeMeWhiteli" href="#0">DSN1</a></li>
                            <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DEX2')}><a id="makeMeWhiteli" href="#0">DEX2</a></li>
                            <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DXP1')}><a id="makeMeWhiteli" href="#0">DXP1</a></li>
                            <li className="menu-item" id="makeMeWhite" onClick={(e, city) => handleSelectCity(e, 'DCF1')}><a id="makeMeWhiteli" href="#0">DCF1</a></li>
                        </ol>
                    </li>
                </ol>
            )
        } else {
            let stationList = []
            if (props.station) {
                props.station.forEach( ele => {
                    stationList.push(
                        <li className="menu-item" onClick={(e, city) => handleSelectCity(e, `${ele}`)}><a href="#0">{ele}</a></li>
                    )
                })
            }
            setStationOptions(
                <ol>
                    <li className="menu-item"><a href="#0">{selectedCity}</a>
                        <ol className="sub-menu">
                            {stationList}
                        </ol>
                    </li>
                </ol>
            )
        }
    }, [props])

    return (
        <>
            {errorMessage}
            <div className='home_content' >
                <NavigationBar title='Driver Documents' superUser={props.superUser ? true : false} email={props.user_email}/>
                <div className='main_content_forms'>
                    <div className='left_of_forms'>
                        <div className='top_three_forms_list'>
                            <nav class="menu_smaller" id='makeThisnotAppear'>
                                {stationOptions}
                            </nav>
                            <button className='compliance_add_driver_button_driver_docs' onClick={handleDeactivation}>
                                <span className='span_in_complaince_button'>Offboard</span> 
                            </button>
                        </div>
                        <div className='driver_list_container_forms'>
                            <br />
                            {driverList}
                        </div>
                    </div>
                    <div className='right_of_forms'>
                        <div className='forms_divs_name_search' onKeyDown={handleArrowKeys} tabIndex="0">
                            <input className='search_bar_forms' type="text" name='Name' value={nameValue} onChange={handleChange} autoComplete='off'/>
                            <div className={`${makeSearchBarVisible}`} ref={divList => {
                                if (!divList) return;
                                setNameList(divList)
                            }}>
                                {shorterList.length > 0 ? shorterList : driverSearchArray}
                            </div>
                        </div>
                            {content}
                    </div>
                </div>
            </div>
        </>
    )
}

export default DriverDocuments